
export const shiftWorkVI = {
    categoryConfig : {
      filter : {
          all : "Tất cả",
          pending : "Chưa duyệt",
          approved : "Đã duyệt",
      }
    },
    "shiftWorkSider": {
        "headingLabel": "Chấm công",
        "information": "Thông tin chi tiết",
        "midShiftSettings": "Mid Shift Settings",
        "workSchedules": "Phân Ca làm việc",
        "workScheduleAdd": "Tạo mới phân ca làm việc",
        "workScheduleUpdate": "Cập nhật phân ca làm việc",
        "noTime" : ""
    },
    "shiftWorkTitle": {
        "title": "Tiêu Đề",
        "assignmentType": "Kiểu phân ca",
        "weekly" : "Lặp theo tuần",
        "fixed_date" : "Theo ngày cố định",
        "period" : "Theo chu kỳ ngày",
        "date_range" : "Theo khoảng ngày",
        "startDate": "Từ ngày",
        "endDate": "Đến ngày",
        "createDate": "Ngày tạo",
        "status": "Trạng thái",
        "assign_department_position" : "Phân ca theo phòng ban vị trí",
        "assign_personnel" : "Phân ca cá nhân",
    },
    "shiftWorkMenu": {
        "addShiftWork": "Tạo mới phân ca",
        "editShiftWork" : "Sửa phân ca làm việc",
        "deleteShiftWork" : "Xóa phân ca làm việc",
        "approvalShiftWork" : "Duyệt phân ca",
        "unApprovalShiftWork" : "Hoàn duyệt phân ca"
    },
    "shiftWorkForm": {
        "week" : "Thứ trong tuần",
        "shift" : "Ca làm việc",
        "title": "Tiêu Đề",
        "titleEnter": "Nhập tiêu đề ",
        "titleEnterMessage": "Tiêu đề là trường bắt buộc!",

        "nameTypeShiftWork" : "Kiểu phân ca",
        "nameTypeShiftWorkMessage" : "Kiểu phân ca là trường bắt buộc!",
        "nameTypeShiftWorkEnter" : "Chọn kiểu phân ca ",

        "typeShift" : "Loại ca",
        "typeShiftMessage" : "Loại ca là trường bắt buộc!",
        "typeShiftEnter" : "Chọn loại ca ",

        "departments" : "Phòng ban",
        "departmentsEnter" : "Chọn phòng ban",

        "positions" : "Vị trí",
        "positionsEnter" : "Chọn vị trí",

        "assignmentId" : "Phân công ",
        "assignmentIdMessage" : "Phân công là trường bắt buộc! ",
        "assignmentIdEnter" : "Chọn Phân công ",


        "startDate" : "Từ ngày",
        "endDate" : "Tới ngày" ,

        "assignmentDetails" : "Chi tiết phân ca" ,
        "generalInformation" : "Thông tin chung" ,
        "assignmentRepeatMessage" : "Phân công này sẽ lăp lại" ,
        "day" : "Ngày" ,
        "dayOfWeek" : "Thứ" ,

        "repeatNumber" : "Nhập số lần lặp",
        "repeatNumberEnter" : "ngày một lần",

        "employeeId" : "Mã nv",
        "assignmentTypeEmp" : "Nhân sự",

        "employeeSearchEnter" : "Tìm kiếm nhân viên ",
        "employeeSearchMessage" : "Vui lòng chọn nhân viên",

        "shifts" : "Chọn ca làm việc",

       "nameEmployee" : "Tìm kiếm nhân viên",


        "approvalId" : "Người duyệt",
        "approvalIdMessage" : "Người duyệt là trường bắt buộc!",
        "approvalIdEnter" : "Tìm kiếm người duyệt" ,

    },

    "assignBy" : {
        "repeatWeek" : "Lặp theo tuần",
        "byFixDate" : "Theo ngày cố định",
        "dayCycle" : "Lặp theo chu kì",
        "rangeDate" : "Lặp theo khoảng ngày"
    },
    "shiftData" : {
        "weekOff" : "Nghỉ Tuần",
        "cancelOff" : "Nghỉ thường/Hủy Ca",
        "autoTakeShift" : "Tự động lấy ca"
    }	,

    "assignByRepeatWeekly" : {
        "monday" : "Thứ 2",
        "tuesday" : "Thứ 3",
        "wednesday" : "Thứ 4",
        "thursday" : "Thứ 5",
        "friday" : "Thứ 6",
        "saturdayOdd" : "Thứ 7 chẵn",
        "saturdayEven" : "Thứ 7 lẻ",
        "sunday" : "Chủ nhật"

    },

    "messageShiftWork" : {
        "startDateEqual" : "Ngày kết thúc phải lớn hơn ngày bắt đầu",
        "chooseStartDate" : "Chọn ngày bắt đầu trước",
        "confirmDelete" : "Bạn có muốn xoá không!",
        "delete" : "Xóa phân ca thành công!",
        "approval" : "Duyệt phân ca thành công!",
        "unApproval" : "Hoàn duyệt Phân ca thành công!",
        "confirmApproval" : " Bạn có chắc chắn là muốn duyệt",
        "confirmUnApproval" : " Bạn có chắc chắn là muốn hoàn duyệt ",
        "approved" : "Đã duyệt",
        "pending" : "Đang chờ duyệt"
    },
    "create_quick_shift_work" : "Tạo ca nhanh"

}
